export default "__VITE_ASSET__Bt4ga2az__"